import { useTranslation } from 'react-i18next';
import { Divider, HStack, Image, Text } from '@chakra-ui/react';
import RoundedBox from 'ui/molecules/RoundedBox';
import { numberToString } from 'utils/stringUtils';
import useTVAText from 'utils/hooks/useTVAText';
import { useSelector } from 'react-redux';
import { BusinessChoiceSelector } from 'store/selectors';
import { PromoCodeResult } from 'api';

type Props = {
  price: number;
  promoPrice: number;
  numPanels: number;
  promoCode?: PromoCodeResult;
  isPreview: boolean;
};

const SummaryPriceBox = ({
  price,
  promoPrice,
  promoCode,
  numPanels,
  isPreview,
}: Props) => {
  const { t } = useTranslation();
  const businessChoice = useSelector(BusinessChoiceSelector);
  const tvaTxt = useTVAText(businessChoice);
  const partnerInfo = promoCode?.partnerInformation;

  return (
    <RoundedBox
      pt="30px"
      pb={8}
      color={partnerInfo?.fontColor || 'white'}
      bgColor={partnerInfo?.backgroundColor || 'secondaryColor'}
      // if there is a form, we don't want the border radius on bottom
      borderRadius={isPreview ? '10px' : '10px 10px 0px 0px'}
      center
    >
      {partnerInfo?.iconUrl && (
        <Image
          pt="10px"
          src={partnerInfo?.iconUrl}
          alt={partnerInfo?.name}
          maxW="200px"
        />
      )}
      {partnerInfo?.partnerFreeText && (
        <Text
          w="full"
          textAlign="center"
          pt="20px"
          px="20px"
          dangerouslySetInnerHTML={{ __html: partnerInfo?.partnerFreeText }}
        />
      )}

      {partnerInfo && <Divider borderColor="#ffffffcc" w="80%" my="25px" />}

      <Text fontSize="lg" fontWeight="bold" textAlign="center">
        {t(`summary.cost`)} {numPanels >= 25 ? '*' : ''}
      </Text>
      {/* <Text fontSize="sm" textAlign="center">
        {t(`summary.cost.withoutPromo`)}
      </Text> */}

      {promoPrice && promoPrice !== price && (
        <Text fontWeight="bold" fontSize="120%" as="s">
          {numberToString(price)}
          {t('common.eur')}
        </Text>
      )}

      <HStack borderRadius="5px">
        <Text marginTop={-1} fontWeight="bold" fontSize="5xl">
          {numberToString(promoPrice || price)}
          {t('common.eur')}
        </Text>
        <Text size="xl" fontWeight="bold">
          ({tvaTxt})
        </Text>
      </HStack>
      <Text fontSize="sm">{t('summary.cost.included')}</Text>
      {businessChoice === 'b2c' && (
        <Text w="full" px={4} pt={5} textAlign="center" fontSize="xs">
          {t('summary.detail.taxes')}
        </Text>
      )}
    </RoundedBox>
  );
};

export default SummaryPriceBox;
